import type {CitationTarget,FileRecord} from '@reados/contracts';
import {resolveReference,sourceReferenceIdentity,sourceReferenceUrl} from '@reados/renderer/references';
import {resolveReaderNavigation,type ReaderNavigation} from './reader-references';

export type SourceFileResolver=(fileId:string,contentRevision:string,signal:AbortSignal)=>Promise<{file:FileRecord}>;

/** No browser catalog or fallback path can replace the identity carried by a lecture. */
export async function resolveLectureNavigation(source:string|CitationTarget,origin:string,resolve:SourceFileResolver,signal:AbortSignal):Promise<ReaderNavigation&{file:FileRecord}>{
 const identity=typeof source==='string'?sourceReferenceIdentity(source,origin):source.fileId&&source.contentRevision?{fileId:source.fileId,contentRevision:source.contentRevision}:null;
 if(!identity||!/^[a-f0-9]{64}$/.test(identity.contentRevision))throw new Error('这条来源链接缺少可验证的资料版本，请重新编译讲义。');
 const {file}=await resolve(identity.fileId,identity.contentRevision,signal);
 if(signal.aborted)throw new DOMException('已取消来源跳转。','AbortError');
 if(!file||file.id!==identity.fileId||file.contentRevision!==identity.contentRevision)throw new Error('引用来源已经变化，无法打开讲义所引用的版本。');
 const target=typeof source==='string'?resolveReference(source,[file],origin)?.target:{...source,path:file.sandboxPath};
 if(typeof source==='string'&&target){
  const query=sourceReferenceUrl(source,origin)!.searchParams;
  const pageKeys=['page_number','pageNumber','page'],labelKeys=['p','page_locations','page_label','pageLabel'];
  const timeKeys=['t','time_locations','timeLocations','time','timestamp','range','start','start_seconds','startSeconds','end','end_seconds','endSeconds'],lineKeys=['line','line_number','endLine','end_line_number'];
  const any=(keys:string[])=>keys.some(key=>query.has(key));
  if([...pageKeys,...labelKeys,...timeKeys,...lineKeys].some(key=>query.getAll(key).length>1)
   ||file.kind==='pdf'&&(any(pageKeys)&&!target.pageNumber||any(labelKeys)&&!target.pageLabel)
   ||file.kind==='video'&&any(timeKeys)&&!target.timeLocations?.length
   ||['text','other'].includes(file.kind)&&any(lineKeys)&&!target.lineStart)throw new Error('来源链接的位置参数无效，无法准确定位。');
 }
 const navigation=target&&resolveReaderNavigation(target,[file],origin);
 if(!navigation)throw new Error('这条来源链接无效，无法定位到原材料。');
 return {...navigation,file};
}
